"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var spacesRegex = /[- ]/g;
var nonNumericRegex = /[^0-9]/g;
var twoPartUsRegex = /^([0-9]{5})-[0-9]{4}$/;
var padWithTrailingZeros = function (str, length) {
    while (str.length < length) {
        str += '0';
    }
    return str.substring(0, length);
};
var getZipFallbacks = function (zip, country) {
    var fallbacks = [zip];
    var push = function (tryZip) {
        if (!(fallbacks.indexOf(tryZip) >= 0))
            fallbacks.push(tryZip);
    };
    if (zip.length > 0 && country === 'IE') {
        push('');
    }
    var isTwoPartUsZip = country === 'US' && zip.search(twoPartUsRegex) >= 0;
    if (isTwoPartUsZip) {
        push(zip.replace(twoPartUsRegex, '$1'));
    }
    if (zip.search(nonNumericRegex) >= 0) {
        var reduced = padWithTrailingZeros(zip.replace(nonNumericRegex, ''), 5);
        push(reduced);
    }
    if (!isTwoPartUsZip && zip.search(spacesRegex) >= 0) {
        push(zip.replace(spacesRegex, ''));
    }
    return fallbacks;
};
exports.default = getZipFallbacks;
